export default "__VITE_ASSET__BmiSHBlR__"